import { render, staticRenderFns } from "./DataRequestItem.vue?vue&type=template&id=13f8c4f6&scoped=true"
import script from "./DataRequestItem.vue?vue&type=script&lang=js"
export * from "./DataRequestItem.vue?vue&type=script&lang=js"
import style0 from "./DataRequestItem.vue?vue&type=style&index=0&id=13f8c4f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f8c4f6",
  null
  
)

export default component.exports